declare global {
  interface Window {
    apa?: (eventName: string, properties?: Record<string, string | number | boolean | undefined>) => void;
  }
}

export interface ContactLeadPayload {
  name: string;
  email: string;
  company: string;
  phone: string;
  companySize: string;
  priorityNeed: string;
  message: string;
  pagePath: string;
  industry?: string;
  plan?: string;
  preferredContact?: string;
  appointmentVolume?: string;
  sourceSurface?: string;
}

export function trackEvent(
  eventName: string,
  properties?: Record<string, string | number | boolean | undefined>
) {
  if (typeof window === "undefined" || typeof window.apa !== "function") return;
  window.apa(eventName, properties);
}

export async function submitContactLead(payload: ContactLeadPayload) {
  const response = await fetch("/api/lead", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let message = "Lead request failed";
    try {
      const body = await response.json();
      if (typeof body?.error === "string") message = body.error;
    } catch {
      // Keep the generic message when the server returns non-JSON.
    }
    throw new Error(message);
  }

  return response.json();
}
